import { getInfoByError } from './manageErrors';
import triggerEvent from '../services/biSiteLogger';
import triggerEventEditor from '../services/biEditorLogger';
import biData from '../../bi/errorEvents.json';
import biDataEditor from '../../bi/editorEvents.json';
import WixService from '../services/WixService';
import { stringifyErrMsg } from './utils';

const viewMode = WixService.getViewMode();

const sendBIMediaErrors = (error, isEmptyAccount) => {
  const data = getInfoByError(error, isEmptyAccount);
  if (viewMode === 'editor') {
    triggerEventEditor({
      ...biDataEditor.VIEW_ERROR_ON_WIDGET,
      description: data.message,
      api_description: stringifyErrMsg(error.message),
    });
  } else {
    triggerEvent({
      ...biData.EMPTY_STATE,
      description: data.message,
      api_description: stringifyErrMsg(error.message),
    });
  }
  return data;
};

export default sendBIMediaErrors;
